export default __webpack_public_path__ + "static/media/reanimacion_cardiopulmonar.b5796aab.pdf";